/**
 * Base JS
 */

// Assuming site header is fixed, add a class to indicate when it's "stuck"
const siteHeader = document.querySelector(".site-header");
const siteHeaderPinnedThreshold = 20; // threshold in pixels that we'll switch to pinned
let siteHeaderScrollTimeoutId = 0;
window.addEventListener(
    "scroll",
    () => {
        siteHeaderScrollTimeoutId && window.cancelAnimationFrame(siteHeaderScrollTimeoutId);
        siteHeaderScrollTimeoutId = window.requestAnimationFrame(() => {
            siteHeader.classList.toggle("site-header--is-pinned", window.scrollY > siteHeaderPinnedThreshold);
        });
    },
    false
);

// When clicking on a primary nav link, close the mobile menu
// (because on this site, many of the nav links are anchor links)
// Also, trigger the nav pinned style as soon as we click a link
const navStatusElement = document.querySelector(".site-header__mobile-nav-status");
const siteNavlinks = document.querySelector(".site-header__nav-links");
siteNavlinks.addEventListener("click", (e) => {
    navStatusElement.checked = false;
});

/**
 * Animation
 */

// the below approach assumes:
// sections get an "animate-section" class, so that they can trigger animations
// elements within that section get both:
//     an animation class (e.g. "animate-in-right", "animate-in-fade", etc.) to control what animation is used
//     an order class (e.g. "animate-order-1", "animate-order-2", etc.) to control when the animation occurs

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// get sections that we will use as triggers
const elementsToAnimate = gsap.utils.toArray([".animate"]);

// do we have anything to animate?
if (elementsToAnimate.length > 0) {
    // add this so we can adjust css when JS is being processes
    document.body.classList.add("via-js");

    // possible classes that can be added to elements and associated animations
    const animations = {
        "animate-in-right": {
            opacity: 0,
            x: -50,
        },
        "animate-in-down": {
            opacity: 0,
            y: -50,
        },
        "animate-in-up": {
            opacity: 0,
            y: 50,
        },
        "animate-in-left": {
            opacity: 0,
            x: 50,
        },
        "animate-in-fade": {
            opacity: 0,
        },
    };

    // settings that each order class gets in timeline
    const animationDuration = 0.4;

    // set up triggers and timelines
    for (const elementToAnimate of elementsToAnimate) {
        let scrollTriggerSettings = {
            scrollTrigger: {
                trigger: elementToAnimate,
                start: "top 80%",
            },
        };

        for (let [className, animation] of Object.entries(animations)) {
            if (elementToAnimate.classList.contains(className)) {
                gsap.from(elementToAnimate, {
                    ...animation,
                    ...scrollTriggerSettings,
                });
                break;
            }
        }
    }
}
